// ===================================
// PUBLIC NAVBAR COMPONENT
// src/components/layout/PublicNavbar.js
// For landing page and public pages
// ===================================

import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './PublicNavbar.css';

const PublicNavbar = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const isLandingPage = location.pathname === '/';

  return (
    <nav className={`public-navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="public-navbar-container">
        <Link to="/" className="public-navbar-logo">
          <div className="logo-icon">🎯</div>
          <span className="logo-text">Career-Coach.AI</span>
        </Link>

        {/* Desktop Navigation */}
        <div className="public-navbar-links">
          {isLandingPage && (
            <>
              <button onClick={() => scrollToSection('features')} className="nav-link">
                Features
              </button>
              <button onClick={() => scrollToSection('how-it-works')} className="nav-link">
                How It Works
              </button>
              <button onClick={() => scrollToSection('pricing')} className="nav-link">
                Pricing
              </button>
              <button onClick={() => scrollToSection('testimonials')} className="nav-link">
                Testimonials
              </button>
            </>
          )}
        </div>

        <div className="public-navbar-actions">
          {isAuthenticated ? (
            <Link to="/app/dashboard" className="btn btn-primary">
              Go to Dashboard
            </Link>
          ) : (
            <>
              <Link to="/login" className="btn btn-ghost">
                Sign In
              </Link>
              <Link to="/register" className="btn btn-primary">
                Get Started
              </Link>
            </>
          )}
        </div>

        {/* Mobile Menu Button */}
        <button 
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        {isLandingPage && (
          <>
            <button onClick={() => scrollToSection('features')} className="mobile-link">
              Features
            </button>
            <button onClick={() => scrollToSection('how-it-works')} className="mobile-link">
              How It Works
            </button>
            <button onClick={() => scrollToSection('pricing')} className="mobile-link">
              Pricing
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="mobile-link">
              Testimonials
            </button>
          </>
        )}
        <div className="mobile-actions">
          {isAuthenticated ? (
            <Link to="/app/dashboard" className="btn btn-primary btn-block" onClick={() => setIsMobileMenuOpen(false)}>
              Go to Dashboard
            </Link>
          ) : (
            <>
              <Link to="/login" className="btn btn-ghost btn-block" onClick={() => setIsMobileMenuOpen(false)}>
                Sign In
              </Link>
              <Link to="/register" className="btn btn-primary btn-block" onClick={() => setIsMobileMenuOpen(false)}>
                Get Started
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default PublicNavbar;
